// extracted by mini-css-extract-plugin
module.exports = {"container":"_-_-pharmacy-src-input-dropdownMenu-dropdownMenuGroup__container--8PvF_"};